const BIGDAY_LOADING = 'BIGDAY_LOADING';
const GET_BIGDAYS = 'GET_BIGDAYS';
const UPDATE_BIGDAY = 'UPDATE_BIGDAY';
const POST_BIGDAY = 'POST_BIGDAY';
const DELETE_BIGDAY = 'DELETE_BIGDAY';
const BIGDAY_ERROR = 'BIGDAY_ERROR';

export {
  BIGDAY_LOADING,
  GET_BIGDAYS,
  UPDATE_BIGDAY,
  POST_BIGDAY,
  DELETE_BIGDAY,
  BIGDAY_ERROR,
};
